const ProfileStatusEnum = Object.freeze({
    PENDING: 'PENDING',
    COMPLETE: 'COMPLETE'
});

export default ProfileStatusEnum;
